import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import classnames from 'classnames';
import { ReactElement, useEffect, useState } from 'react';
import { BloomreachVideoProps } from './index';
import ReactPlayer from 'react-player/lazy';

const componentName = 'bloomreach-video';

const BloomreachVideo = ({ className, videoUrl }: BloomreachVideoProps): ReactElement | null => {
    const [mounted, setMounted] = useState(false);
    const [playerKey, setPlayerKey] = useState(0);

    useEffect(() => {
        setMounted(true);

        /**
         * Handle page show event and re-render the player when the page is reloaded
         * from the back/forward-cache. This is a workaround for Safari where the video
         * player is not re-rendered after the page is reloaded from the cache.
         */
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) {
                setPlayerKey(Date.now());
            }
        };

        window.addEventListener('pageshow', handlePageShow);
        return () => window.removeEventListener('pageshow', handlePageShow);
    }, []);

    if (!mounted) {
        return SKIP_RENDER;
    }

    return (
        <div className={classnames(componentName, className)}>
            <ReactPlayer
                key={playerKey}
                width="100%"
                height="100%"
                playing
                loop
                muted
                controls={false}
                url={videoUrl}
                playsinline
            />
        </div>
    );
};

export default BloomreachVideo;
